import { useEffect, useRef } from 'react';

/**
 * Custom hook for getting previous value
 *
 * @see https://blog.logrocket.com/how-to-get-previous-props-state-with-react-hooks/
 *
 * @param value Value to save to previous state
 *
 * @todo move to generic place on first reuse
 *
 * @example
 *  // the App where the hook is used
 *  function Counter() {
 *    const [count, setCount] = useState(0);
 *    // 👇 look here
 *    const prevCount = usePrevious(count)
 *
 *    return <h1>Now: {count}, before: {prevCount}</h1>;
 *  }
 */
export function usePrevious<T>(value: any) {
  const ref = useRef<T>();
  // executed after function returns
  // therefore ref.current will be replaced
  // after caller gets previous value
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
